import "./App.css";
import * as React from "react";
import Layout from "./pages/Layout/Layout";
import "bootstrap/dist/css/bootstrap.min.css";

// export const baseUrl = process.env.BASE_URL

function App() {
  return (
    <div>
      <Layout />
    </div>
  );
}

export default App;
